import { Services } from "appworks/services/services";
import { ButtonControl } from "appworks/ui/controls/standard/button/button-control";

export class GamevyAutoSpinStopControl extends ButtonControl {
    protected onClick(): void {
        Services.autoplay.stop();
    }
}
